import {Outlet, useLocation, useNavigate} from "react-router-dom";
import * as React from 'react'
import {Fragment, useEffect, useLayoutEffect, useRef, useState} from 'react'
import {Dialog, Transition} from '@headlessui/react'
import UserMenu from "../features/UserMenu";
import {MenuItemType} from "@commons/mapping/MenuItem";
import {alignMenu, selectMenu} from "../core/menu/slice";
import MenuItem from "../features/Menu";
import {historyApp} from "@helpers/history";
import {useAppDispatch, useAppSelector} from "@hooks/redux-hooks/hooks";
import {IconAlignJustified, IconBell, IconPrinter, IconX, IconZoom} from "@tabler/icons-react";
import PrinterIcon from "../icons/PrinterIcon";

export interface OutletContexParams {
    headerHeight?: number
};
export const Layout: React.FC<{ minuti?: number }> = ({minuti}) => {
    const [params, setParams] = React.useState<OutletContexParams>({});
    const headerRef = useRef<HTMLDivElement | null>(null);

    const navigation: MenuItemType[] = useAppSelector(selectMenu);
    const location = useLocation();
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(alignMenu({newStato: location.pathname})); // SOLO prima volta per allineare il menu alla rotta corrente (ad. esempio dopo F5!)
    }, [dispatch]) // N.B. NON location DEVE essere valutato solo la prima volta!

    const [sidebarOpen, setSidebarOpen] = useState(false)
    const logo = (<img
        className="h-4 w-auto"
        /*src="https://tailwindui.com/img/logos/mark.svg?color=blue&shade=600"*/
        src={`${process.env.PUBLIC_URL}/favicon_ericed.ico`}
        alt="FPNet.HR Powered by ERICED"
    />)

    // init custom history object to allow navigation from
    // anywhere in the react app (inside or outside components)

    historyApp.navigate = useNavigate();
    historyApp.location = useLocation();

    /* da usare all'esterno dei componenti
    const newStato = `/lavoratori/retribuzione`;
    historyApp.navigate(newStato);
    dispatch(alignMenu({newStato, oldStato: historyApp.location.pathname}));
    */
    useEffect(() => {
        if (headerRef.current) {
            const clientHeight = headerRef.current.clientHeight;
            setParams(params => ({...params, headerHeight: clientHeight}));
        }
    }, [headerRef]);
    //console.log('Layout: params', params);
    let navigate = useNavigate();

    const showHeader = true;
    return (
        <div>
            {/* sidebar for mobile */}
            <Transition.Root show={sidebarOpen} as={Fragment}>
                <Dialog as="div" className="relative z-40 lg:hidden" onClose={setSidebarOpen}>
                    <Transition.Child
                        as={Fragment}
                        enter="transition-opacity ease-linear duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="transition-opacity ease-linear duration-300"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-600 bg-opacity-75"/>
                    </Transition.Child>

                    <div className="fixed inset-0 z-40 flex">
                        <Transition.Child
                            as={Fragment}
                            enter="transition ease-in-out duration-300 transform"
                            enterFrom="-translate-x-full"
                            enterTo="translate-x-0"
                            leave="transition ease-in-out duration-300 transform"
                            leaveFrom="translate-x-0"
                            leaveTo="-translate-x-full"
                        >
                            <Dialog.Panel className="relative flex w-full max-w-xs flex-1 flex-col bg-white pt-5 pb-4">
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-in-out duration-300"
                                    enterFrom="opacity-0"
                                    enterTo="opacity-100"
                                    leave="ease-in-out duration-300"
                                    leaveFrom="opacity-100"
                                    leaveTo="opacity-0">
                                    <div className="absolute top-0 right-0 -mr-12 pt-2">
                                        <button
                                            type="button"
                                            className="ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                                            onClick={() => setSidebarOpen(false)}>
                                            <IconX className="h-6 w-6 text-white" aria-hidden="true"/>
                                        </button>
                                    </div>
                                </Transition.Child>
                                <div className="flex flex-shrink-0 items-center px-4">
                                    {logo}
                                </div>
                                <div className="mt-5 h-0 flex-1 scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-gray-300 overflow-y-scroll">
                                    <nav className="space-y-1 px-2">
                                        {navigation.map((item, index) => (
                                            <MenuItem key={index} index={index} text="text-base font-medium" siblingItems={navigation}/>
                                        ))}
                                    </nav>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                        <div className="w-14 flex-shrink-0" aria-hidden="true">
                            {/* Dummy element to force sidebar to shrink to fit close icon */}
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>

            {/* Static sidebar for desktop */}
            <div className="hidden lg:fixed lg:inset-y-0 lg:flex lg:w-64 lg:flex-col">
                {/* Sidebar component, swap this element with another sidebar if you like */}
                <div className="flex flex-grow flex-col overflow-y-auto border-r border-gray-200 bg-white pt-5">
                    <div className="flex flex-shrink-0 items-center px-4">
                        {logo}
                    </div>

                    <div className="mt-5 flex flex-grow flex-col scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-gray-300 overflow-y-scroll">
                        <nav className="flex-1 space-y-1 px-2 pb-4">
                            {navigation.map((item, index) => (
                                <MenuItem key={index} index={index} text="text-sm font-medium" siblingItems={navigation}/>
                            ))}
                        </nav>
                    </div>

                </div>
            </div>

            {/*header e outlet*/}
            <div className="flex flex-1 flex-col lg:pl-64">
                {/* ****** HEADER ****** */}
                {showHeader &&
                    <div ref={headerRef} className="sticky top-0 z-10 flex h-16 flex-shrink-0 bg-white shadow">
                        <button
                            type="button"
                            className="border-r border-gray-200 px-4 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500 lg:hidden"
                            onClick={() => setSidebarOpen(true)}>
                            <IconAlignJustified className="h-6 w-6"/>
                        </button>

                        <div className="flex flex-1 justify-between px-4">
                            <div className="flex flex-1">
                                <form className="flex w-full lg:ml-0" action="#" method="GET">
                                    <div className="relative w-full text-gray-400 focus-within:text-gray-700">
                                        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center">
                                            <IconZoom className="h-5 w-5"/>
                                        </div>
                                        <input id="search-field"
                                               className="block h-full w-full border-transparent py-2 pl-8 pr-3 placeholder-gray-500 focus:border-transparent focus:placeholder-gray-400 focus:outline-none focus:ring-0 sm:text-sm"
                                               placeholder="Search" type="search" name="search"/>
                                    </div>
                                </form>
                            </div>
                            <div className="ml-4 flex items-center lg:ml-6">

                                {minuti}&nbsp;
                                <ShowWindowDimensions/>

                                <button type="button"
                                        className="rounded-full bg-white p-1 mr-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1"
                                        onClick={() => {
                                            navigate("spool")
                                        }}>
                                    <PrinterIcon className="h-6 w-6"/>
                                </button>

                                <button type="button"
                                        className="rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1">
                                    <IconBell className="h-6 w-6" strokeWidth={1.5}/>
                                </button>

                                {/*Profile dropdown*/}
                                <UserMenu/>
                            </div>
                        </div>
                    </div>
                }

                {false && <main className="flex-1 h-screen">
                    {/* min-svh: per adattare il div al 92% dello schermo disponibile. in questo modo non vengono "tagliate" le select che stanno in basso nei form.
                        NO > di 92, altrimenti compare scrollbar nativa del browser*/}
                    <div className="py-6 px-2 lg:px-6 scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-gray-300 overflow-y-scroll text-sm min-svh">
                        {/* Replace with your content */}
                        <Outlet/>
                        {/* /End replace */}
                    </div>
                </main>}

                <main className="flex-1 h-screen">
                    <div className="text-sm py-6 px-2 sm:px-4 lg:px-6">
                        <Outlet context={params}/>
                    </div>
                </main>

            </div>
        </div>
    )
}

export default Layout;

// TODO SARA: RIMUOVERE QUANDO TERMINATO...
function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
        function updateSize() {
            setSize([window.innerWidth, window.innerHeight]);
        }

        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
}

function ShowWindowDimensions(props: any) {
    const [width, height] = useWindowSize();
    if (process.env.NODE_ENV !== 'development')
        return <></>
    return (<div className="text-xs inline-flex">
        <span>Window size: {width} x {height}</span>&nbsp;&nbsp;&nbsp;
        {(window.innerWidth < 640) && <div>ND - XS</div>}
        {(window.innerWidth >= 640 && window.innerWidth < 768) && <div>SM</div>}
        {(window.innerWidth >= 768 && window.innerWidth < 1024) && <div>MD</div>}
        {(window.innerWidth >= 1024 && window.innerWidth < 1280) && <div>LG</div>}
        {(window.innerWidth >= 1280 && window.innerWidth < 1536) && <div>XL</div>}
        {window.innerWidth >= 1536 && <div>2XL</div>}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </div>)
}